import React from 'react';

import FormComponentV2 from '../../../../../../../../../common/genericComponents/redesign/formComponentV2/formComponentV2';
import InputComponentV2 from '../../../../../../../../../common/genericComponents/redesign/inputComponentV2/inputComponentV2';
import SeparatorComponent from '../../../../../../../../../common/genericComponents/separatorComponent/separatorComponent';

import VIDABOO_CONSTANTS from '../../../../../../../../../../config/consts';

const QaFormComponent = ({
  isAddQAForm = false,
  isProposedQASelected = false,
  isViewQaForm = false,
  showShakeAnim = false,
  invalidFieldIds = [],
  qaFieldObj = {},
  spinnerType = null,
  handleQAFormChanges = () => {},
  onFormClose = () => {},
  onFormSubmit = () => {},
  qaImprovementFlowObject = null,
}) => {
  const formTitle =
    qaImprovementFlowObject?.title ??
    (isViewQaForm
      ? 'Question details'
      : isAddQAForm
        ? 'Add new question'
        : isProposedQASelected
          ? 'Review question and answer'
          : 'Update question details');
  const formSubTitle = qaImprovementFlowObject?.subTitle;
  const leftBtnTxt = qaImprovementFlowObject?.leftBtnTxt ?? 'Close';
  const rightBtnTxt =
    qaImprovementFlowObject?.rightBtnTxt ??
    (isAddQAForm ? 'Add' : isProposedQASelected ? 'Accept' : 'Save');
  const leftBtnAction = qaImprovementFlowObject?.leftBtnAction ?? onFormClose;
  const rightBtnAction =
    qaImprovementFlowObject?.rightBtnAction ?? onFormSubmit;
  return (
    <FormComponentV2
      isRightBtnDisabled={invalidFieldIds.length > 0}
      showRightBtn={!isViewQaForm}
      showRightBtnSpinner={spinnerType !== null}
      showShakeAnim={showShakeAnim}
      formTitle={formTitle}
      formSubTitle={formSubTitle}
      leftBtnTxt={leftBtnTxt}
      rightBtnTxt={rightBtnTxt}
      onLeftBtnClicked={leftBtnAction}
      onRightBtnClicked={rightBtnAction}>
      <SeparatorComponent />
      <InputComponentV2
        id="question"
        disabled={isViewQaForm}
        isRequired
        noWaitOnInput={true}
        defaultValue={qaFieldObj.question}
        errorMessage="Please provide some value"
        placeholder="Question goes here. e.g. What services do you provide?"
        showCustomError={invalidFieldIds?.includes('question')}
        titleTxt="Question"
        toolTipTxt={
          isViewQaForm
            ? null
            : 'Enter the question you think your customers might ask.'
        }
        validationPattern={VIDABOO_CONSTANTS.VALIDATION_PATTERNS.QA_QUESTION}
        onChange={handleQAFormChanges}
        onInvalidInput={handleQAFormChanges}
        onBlur={handleQAFormChanges}
      />
      <SeparatorComponent />
      <InputComponentV2
        id="answer"
        disabled={isViewQaForm}
        isRequired
        noWaitOnInput={true}
        defaultValue={qaFieldObj.answer}
        errorMessage="Please provide some value"
        inputType="textarea"
        maxLength={800}
        placeholder="Answer goes here. e.g. Our services encompass a wide range of solutions tailored to meet your needs."
        showCustomError={invalidFieldIds?.includes('answer')}
        titleTxt="Answer"
        toolTipTxt={
          isViewQaForm
            ? null
            : 'Enter the answer in respond to question mentioned above.'
        }
        validationPattern={VIDABOO_CONSTANTS.VALIDATION_PATTERNS.QA_ANSWER}
        onChange={handleQAFormChanges}
        onInvalidInput={handleQAFormChanges}
        onBlur={handleQAFormChanges}
      />
      <SeparatorComponent />
    </FormComponentV2>
  );
};

export default QaFormComponent;
